/**
 * Retry predicate for the app-wide React Query QueryClient.
 *
 * Auth-related errors from customFetch must NOT retry: retrying reuses the
 * same expired ID token (token refresh is async via Firebase's
 * onIdTokenChanged listener) and, for session-expired responses, each retry
 * would trigger a fresh logOut — amplifying the storm that used to freeze
 * the browser when many in-flight queries failed simultaneously.
 *
 * Matched error messages:
 *   - "Session expired, please log in again"  (CustomFetch 401 + Firebase Session Expired)
 *   - "Unauthorized: Token refresh initiated"  (CustomFetch 401 + other causes)
 *
 * Everything else follows the default 3-retry policy.
 */
export const isSuppressedAuthError = (error: unknown): boolean => {
	if (!(error instanceof Error)) {return false;}
	return error.message.startsWith('Session expired')
		|| error.message.startsWith('Unauthorized');
};

export const shouldRetryQuery = (failureCount: number, error: unknown): boolean => {
	if (isSuppressedAuthError(error)) {return false;}
	return failureCount < 3;
};
